var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.campaign)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('CampaignFieldsCard',_vm._b({},'CampaignFieldsCard',{
        fields: _vm.campaignFields,
        campaign: _vm.campaign,
        save: _vm.save,
        deleteCampaign: _vm.deleteCampaign,
        cancel: _vm.cancel,
      },false))],1),_c('transition',{attrs:{"name":"fade--slow"}},[(_vm.history.length)?_c('v-flex',{attrs:{"xs12":"","campaign-history__header":""}},[_c('v-subheader',[_vm._v("HISTORY")])],1):_vm._e()],1),_c('transition-group',{staticClass:"flex xs12",attrs:{"name":"list-transition","tag":"div"}},_vm._l((_vm.history),function(entry){return _c('CampaignHistoryCard',_vm._b({key:entry.id},'CampaignHistoryCard',entry,false))}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }